'use client';
import React from 'react';
import useLoader from '@src/hooks/useLoader';
import Loader from '@src/components/loader';
import { loaderTypes } from '@src/constants/loaderTypes';

const VerifyEmailLayout = ({ children }: { children: React.ReactNode }) => {
  const { isLoading, loaderType } = useLoader();
  return (
    <div data-theme="renter">
      {children}
      {loaderType === loaderTypes.GENERAL && <Loader isVisible={isLoading} />}
    </div>
  );
};

export default VerifyEmailLayout;
